import {
  Component,
  input,
  output,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { SchoolSummaryCardComponent } from '../../../../components/school-summary-card/school-summary-card.component';
import { AttributesApiService } from '../../../../services/attributes-api.service';
import { Institution } from '../../../../types/rest-api';

@Component({
  selector: 'app-upgrade-summary',
  standalone: true,
  imports: [MatButton, SchoolSummaryCardComponent],
  templateUrl: './upgrade-summary.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./upgrade-summary.component.scss'],
})
export class UpgradeSummaryComponent implements OnInit {
  private attributesApi = inject(AttributesApiService);

  summaryData = input.required<any>();
  role = input.required<'schuleinheit' | 'schulgemeinde'>();
  loading = input<boolean>(false);

  editProfile = output<void>();
  createProfile = output<void>();

  institutions: Institution[] = [];

  ngOnInit() {
    this.attributesApi.getInstitutions().subscribe(list => {
      this.institutions = list;
    });
  }

  getSelectedInstitutionName(): string {
    const id = this.summaryData().institutionId;
    if (!id) return '';
    return this.institutions.find(i => i.id === id)?.name || '';
  }
}
